import React, {Component} from 'react'

import logo from '../img/logo.svg'
import Arrow from '../img/arrow'

import emailServices from './emailServices'
import { Xhr } from 'hlp'
import validate from '../validator/validator'

import DomainInp from './domain'



class ArForm extends Component {

  constructor(props) {
    super()

    this.state = {
      texts: {},

      lang: props.lang,

      requestSended: false,

      vals: {
        domain: null,
        email: null
      },

      isCoroporateEmail: true,

      minLengthValid: true,
      
      class: "form",
      domainError: false,
      submitted: false,

      API_URL: '',
      BASE_DOMAIN: '',
      needRedirect: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }





  componentWillMount() {
    Xhr.loadJSON( '/constants.json' )
      .then( resp => {
        if ( resp.hasErr ) {
          console.log('resp: ', resp);
          return
        }
        const { value } = resp
        const redir = value.REDIRECT_TO_PLATFORM_AFTER_REGISTER

        this.setState( {
          API_URL: value.API_URL,
          BASE_DOMAIN: value.BASE_DOMAIN,
          needRedirect: redir === true ? true : false
        } )

      } )

  }


  updateLang( lang, texts ) {
    this.setState( {
      lang: lang,
      texts:texts
    } )
  }

  handleBlur(ev) {
    let trg = ev.target
    let val = trg.value
    let type = trg.dataset.type

    if (!type) return

    const newStates = {
      vals: Object.assign( {}, this.state.vals )
    }


    val = validate(trg,type)


    if ( val !== null ) {
      let minLengthValid = this.checkMinLength( trg )
      if ( type === 'email' ) {
        let isCorporate = this.checkIsCorporate( val )
        if ( !isCorporate ) {
          val = null
          newStates.isCoroporateEmail = false
        } else {
          newStates.isCoroporateEmail = true
        }
      } else if ( !minLengthValid ) {
        val = null
        newStates.minLengthValid = false
      } else {
        newStates.minLengthValid = true
      }
    }


    newStates.vals[type] = val ? val : null

    this.setState(newStates)

  }




  handleInputs(ev) {
    let trg = ev.target
    let type = trg.dataset.type
    if (!type) return
    validate( trg,type )
  }





  checkIsCorporate( email ) {
    email = email.toLowerCase()
    const emailService = email.replace(/^.+@/,'')
    let isCorporate = emailServices.indexOf(emailService) === -1

    return isCorporate
  }

  checkMinLength( trg ){
    let minLengthValid = true
    if ( trg.hasAttribute( 'minlength' ) ) {
      let val = trg.value
      if ( val.length >= trg.getAttribute( 'minlength' ) ) {
        return minLengthValid
      } return false
    }

    return minLengthValid
  }



  onSubmit(ev) {
    ev.preventDefault()
    this.setState( { submitted: true } )


    let vals = this.state.vals
    const isRecoverPage = this.props.hasRecoveryParam


    // for ( let key in vals) {
    //   if ( vals.hasOwnProperty(key) && vals[key] === null ) {
    //     if ( isRecoverPage && ( key === 'password' ) ) {
    //       delete vals[ key ]
    //     }
    //   }
    // }

    if ( Object.keys( vals ).some( key => vals[ key ] === null ) ) return

    this.setState( { class: "form loading" } )

    let bThis = this

    if ( isRecoverPage ) {

      const apiVer = this.props.platformVersion

      let data = JSON.stringify( {
        email: vals.email.toLowerCase(),
        platform_name: vals.domain.toLowerCase()
      } )


      if ( apiVer === '3' ) {
        data = new FormData()
        data.append( 'email', vals.email )
        data.append( 'platformName', vals.domain.toLowerCase() )
      }



      const xhr = new XMLHttpRequest()
      const url = `https://api.ar.digital/v${apiVer}` + (
        apiVer === '3' ?
        '/users/recovery-password' :
        '/users/recovery/mail'
      )

      xhr.open('POST', url, true)
      // xhr.setRequestHeader('Content-Type', 'application/json')

      const _this = this

      xhr.onreadystatechange = function() {
        if ( this.readyState !== 4 ) return

        if ( this.status === 200 ) {
          bThis.setState({ class: "form recoverSuccess" })
        } else {
          _this.setState( { class: "form" } )
          console.error(this.status)
        }
      }

      xhr.send(data)

      return false
    }

    this.sendReq(vals)

  }

  sendReq(vals) {
    let lang = this.state.lang
    const baseDomain = this.state.BASE_DOMAIN

    var xhr = new XMLHttpRequest()
    xhr.open( 'POST', this.state.API_URL, true )

    xhr.onload =  ev => {
      if ( ev.target.status !== 200 ) {
        let code = null
        try {
          code = JSON.parse(ev.target.response).code
        } catch(e) {     console.log(e) }

        this.setState( { domainError: code === 3020 } )
        this.setState( { class: "form" } );

        return
      }


      try {
        window.fbq('track', 'CompleteRegistration')
      } catch( e ) { console.log(e) }


      this.setState( { requestSended: true} )

      new Xhr( {
        url: 'https://addreality.com/api/addToList.php',
        method: 'POST',
        body: {
          list: "regDigest",
          email: vals.email,
          lang: lang
        }
      } )

      const platformUrl = vals.domain.toLowerCase() + '.' + baseDomain

      const addToBaseUrl = `https://addreality.${lang === 'ru' ? 'ru' : 'com'}/api/addToBase.php`

      new Xhr( {
        url: addToBaseUrl,
        method: 'GET',
        body: {
          company: platformUrl,
          email: vals.email,
          from: baseDomain
        }
      } )

      if ( this.state.needRedirect === true ) {
        window.location = `http://${platformUrl}`
      }

    }

    const data = {
      email: vals.email.toLowerCase(),
      platform_name: vals.domain.toLowerCase(),
      language: lang
    }

    xhr.send( JSON.stringify( data ) )
  }





  render() {
    const { vals, submitted } = this.state

    let tx = this.props.texts || {}

    if (this.state.requestSended) {
      return (
        <div className="form onSuccess">

          <a href={tx.domainName} target="_blank" rel="noopener noreferrer"><img src={logo} alt="logo" width="130" height="29" className="logo"/></a>

          <p className="success">
            <span dangerouslySetInnerHTML={{__html: tx.success}}></span>
            <b>{this.state.vals.email}</b>
            <span dangerouslySetInnerHTML={{__html: tx.sucessCont}}></span>
          </p>
        </div>
      )
    }

    let txButton = tx.registration

    if ( this.props.hasRecoveryParam ) {
      txButton = tx.recover
    }

    return (

      <div className={this.state.class + ' ' + this.state.lang}>
        <div className="loading"><div className="bg"/><div className="icon"/></div>

        <form onBlur={ev => this.handleBlur(ev)} onSubmit={this.onSubmit}>
          <span className="logo"><img width="130" height="29" src={logo} alt="logo"/></span>

          <DomainInp
            baseDomain={ this.state.BASE_DOMAIN }
            textErr={this.state.minLengthValid ? tx.domainErr : tx.domainLengthErr}
            //textErr={tx.domainErr}
            txt={this.state.domainError ? tx.domainError : tx.domain}
            errClass={this.state.domainError ? "error " : ""}
            txtDesc={tx.domainDesc}
            oninput={()=>{this.setState({domainError: false})}}
            className={ submitted && vals[ 'domain' ] === null ? 'has-error' : '' }
          />

          <label className={'emailInpWrp ' + (!this.state.isCoroporateEmail ? 'error' : '')}>
            <span>{!this.state.isCoroporateEmail ? tx.useCorporateEmail : tx.email}</span>
            <span className="error">{tx.mailErr}</span>
            <input
              name="email"
              maxLength={254}
              type="email"
              data-type="email"
              className={ submitted && vals[ 'email' ] === null ? 'has-error' : '' }
            />
          </label>
					
          <div className="terms">
            {tx.clickBtn} <b>{tx.registration_q}</b>{tx.terms}
            <a href="https://addreality.ru/termsofuse/" target="_blank" rel="noopener noreferrer">{tx.agreement}</a>
            <span dangerouslySetInnerHTML={{__html: tx.after_terms}}/>
          </div>
          <p className="successRec">
            <span>
              <b>{tx.afterRecover}</b>
            </span>
          </p>
          <button
            className="submitBtn"
            type="submit"
            disabled={this.state.domainError}
          >{txButton}
            <Arrow />
          </button>
        </form>
      </div>

    )
  }

}


export default ArForm



// WEBPACK FOOTER //
// ./src/form/form.jsx